module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide",
    on: {
      "mouseover": _vm.stop,
      "mouseout": _vm.move
    }
  }, [_c('div', {
    staticClass: "slideshow"
  }, [_c('transition-group', {
    attrs: {
      "tag": "ul",
      "name": "image"
    }
  }, _vm._l((_vm.imgs), function(img, index) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.mark),
        expression: "index === mark"
      }],
      key: index,
      on: {
        "click": _vm.imgClicked
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_c('img', {
      attrs: {
        "src": img.decorateContent + '@160h_1020w_2e_90Q'
      }
    })])])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "bar"
  }, _vm._l((_vm.imgs), function(item, index) {
    return _c('span', {
      key: index,
      class: {
        'active': index === _vm.mark
      },
      on: {
        "click": function($event) {
          _vm.change(index)
        }
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d459b78","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/academy/SlideShow.vue
// module id = 780
// module chunks = 0